import { hasProductExposure } from "../../../Component/tool/productExposure";
import { parseLiveClosingTime } from "../../User/Live/LiveClosingCountdown";
import "./Live_Manage.css";
import LivePreviewState from "../LiveList/Component/LivePreviewState";
import LiveStatusBadge from "../../../Component/UI/LiveStatusBadge";
import useReviewHostStatus from "../../Broadcast/useReviewHostStatus";
import BroadcastProductCard from "./BroadcastProductCard";
import SellerNotice from "../../../Component/UI/SellerNotice";
import ExpandableNotice from "../../../Component/UI/ExpandableNotice";
import LiveDetail from "../LiveList/LiveDetail";
import LiveSalesTotal from "../LiveList/Component/LiveSalesTotal";
import LiveChatContent from "../LiveList/Component/LiveChatContent";
import { qaUpdated } from "../../Chat/liveQa";
import { sellerNoticeUpdated } from "../../Broadcast/sellerNotice";
import { createPortal } from "react-dom";
import StartNotificationSheet from "./StartNotificationSheet";
/* eslint-disable react/jsx-pascal-case */

import axios from "axios";

import moment from "moment";

import React, { useCallback, useEffect, useRef, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import io, { Socket } from "socket.io-client";

import styled, { StyleSheetManager } from "styled-components";
import api from "../../../Component/axios_Interceptor/api";

import url, { SOCKET_SERVER_URL } from "../../../Component/server";

import {

  Icon,

  RowView2,

} from "../../../Component/style/common_style";


import icon_question_circle_gray from "../../../Image/ic_question_circle_gray.png";

import PurchaseNotice, { usePurchaseNotices } from "../../User/Live/PurchaseNotice";
import AdminLive, { AdminLiveHandle } from "./AdminLive";
import { useSaleProductInfo } from "../../User/Live/useSaleProductInfo";
import { mediaUrl } from "../../../Component/tool/mediaUrl";
import { live_info_type } from "../../User/Live/Live";



interface Live_Start_Props {

  $state: string;

  $select_cam: string;

  $select_mic: string;

}

type props_data_type = {

  seq: number;

  live_seq: number;

  name: string;

  price: number;

  option_check: string;

  init_cnt: number;

  current_cnt: number;

  product_status: string;
  exposure_active?: boolean | null;

  product_num: number | null;

  unique_option1: string[];

  unique_option2: string[];

  exposure_price_mode?: string;
  thumbnail_img?: string | null;
};



const Live_Manage = ({ adminLevel, adminPermissions = [] }: { adminLevel?: string; adminPermissions?: string[] }) => {
  const Navigate = useNavigate();

  const { seq } = useParams();



  const [data, set_Data] = useState<props_data_type | null>();

  const [stockCounts, setStockCounts] = useState<Record<number, number>>({});
  const [productInfoSyncVersion, setProductInfoSyncVersion] = useState(0);
  const { images: productImages } = useSaleProductInfo(data?.seq, true, productInfoSyncVersion);
  const [liveNotice, setLiveNotice] = useState('');
  useEffect(() => {
    let active = true, request = 0;
    setLiveNotice('');
    const refresh = async () => {
      const version = ++request;
      try {
        const { data } = await api.get(url.Communication_url.get_live_notice, { params: { seq, type: 'ln' } });
        if (active && version === request && Array.isArray(data)) setLiveNotice(typeof data[0]?.content === 'string' ? data[0].content : '');
      } catch { /* Keep the last successful notice while the connection recovers. */ }
    };
    void refresh();
    window.addEventListener('focus', refresh);
    return () => { active = false; window.removeEventListener('focus', refresh); };
  }, [seq]);
  const [live_info, set_Live_Info] = useState<live_info_type>();

  const [live_time, set_Live_Time] = useState<string>("00:00:00");
  useEffect(() => {
    const startedAt = parseLiveClosingTime(live_info?.start_dt);
    if (!['방송중', '리허설'].includes(live_info?.live_status || '') || startedAt === null) {
      set_Live_Time('00:00:00');
      return;
    }
    const update = () => {
      const seconds = Math.max(0, Math.floor((Date.now() - startedAt) / 1000));
      set_Live_Time([Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
        .map(value => String(value).padStart(2, '0')).join(':'));
    };
    update();
    const timer = window.setInterval(update, 1000);
    return () => window.clearInterval(timer);
  }, [live_info?.seq, live_info?.start_dt, live_info?.live_status]);


  const [viewer_count, set_Viewer_Count] = useState<number>(0);



  const [livestart, setLivestart] = useState("end");
  const [statusPending, setStatusPending] = useState(false);
  const statusLock = useRef(false);
  const mounted = useRef(true);
  const restartTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const previouslyStopped = useRef(false);
  const [restartPreparing, setRestartPreparing] = useState(false);
  const rememberStopped = (stopped: boolean) => {
    previouslyStopped.current = stopped;
    try {
      const key = `fanbird.broadcast.stopped.${seq}`;
      if (stopped) sessionStorage.setItem(key, "true");
      else sessionStorage.removeItem(key);
    } catch { /* The current screen can still remember its stopped sender. */ }
  };
  useEffect(() => {
    mounted.current = true;
    try { previouslyStopped.current = sessionStorage.getItem(`fanbird.broadcast.stopped.${seq}`) === "true"; }
    catch { /* Browser storage is optional. */ }
    return () => { mounted.current = false; clearTimeout(restartTimer.current); };
  }, [seq]);
  const [live_start, setLive_start] = useState("");

  const [live_finish, setLive_finish] = useState("");

  const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);

  const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([]);

  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [selectedAudio, setSelectedAudio] = useState<string>("");
  const controlsStorageKey = `fanbird.broadcast.controls.${seq}`;
  const [deviceControls, setDeviceControls] = useState(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(controlsStorageKey) || "null");
      return { cameraEnabled: saved?.cameraEnabled !== false, microphoneEnabled: saved?.microphoneEnabled !== false };
    } catch { return { cameraEnabled: true, microphoneEnabled: true }; }
  });
  const [cameraUnavailable, setCameraUnavailable] = useState(false);
  const reviewHost = useReviewHostStatus();
  const cameraEnabled = reviewHost ? !reviewHost.cameraOff : deviceControls.cameraEnabled;
  const microphoneEnabled = reviewHost ? !reviewHost.micMuted : deviceControls.microphoneEnabled;
  const [hostStatusTarget, setHostStatusTarget] = useState<HTMLDivElement | null>(null);
  const [productCameraTarget, setProductCameraTarget] = useState<HTMLDivElement | null>(null);
  const toggleDevice = (device: keyof typeof deviceControls, enabled = !deviceControls[device]) => {
    const next = { ...deviceControls, [device]: enabled };
    try { sessionStorage.setItem(controlsStorageKey, JSON.stringify(next)); }
    catch { /* Device controls still work when browser storage is unavailable. */ }
    setDeviceControls(next);
  };
  const [sdkReady, setSdkReady] = useState(false);
  const [devicesReady, setDevicesReady] = useState(false);
  const [reconnectAttempt, setReconnectAttempt] = useState(0);
  const [connectionError, setConnectionError] = useState("");
  const [externalBroadcast, setExternalBroadcast] = useState(false);
  const [broadcastStatusChecked, setBroadcastStatusChecked] = useState(false);
  const [resumeLocalBroadcast, setResumeLocalBroadcast] = useState(false);
  const observedExternalBroadcast = useRef(false);
  const [showStartNotification, setShowStartNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const dismissStartNotification = useCallback(() => setShowStartNotification(false), []);
  const startNotificationSent = useCallback(() => {
    setShowStartNotification(false);
    setNotificationMessage("시작 알림톡 발송을 접수했습니다.");
  }, []);
  useEffect(() => {
    if (!notificationMessage) return;
    const timer = window.setTimeout(() => setNotificationMessage(""), 5000);
    return () => window.clearTimeout(timer);
  }, [notificationMessage]);
  const localBroadcast = useRef(false);
  const broadcastRef = useRef<AdminLiveHandle>(null);
  const endedBroadcast = useRef(false);
  const stoppingBroadcast = useRef<Promise<void>>(Promise.resolve());
  const [automaticallyEnded, setAutomaticallyEnded] = useState(false);
  const reconnecting = useRef(false);
  const deviceStorageKey = `fanbird.broadcast.devices.${seq}`;
  const [savedDevices] = useState(() => {
    try {
      const saved = JSON.parse(sessionStorage.getItem(deviceStorageKey) || "null");
      return { video: typeof saved?.video === "string" ? saved.video : "", audio: typeof saved?.audio === "string" ? saved.audio : "" };
    } catch { return { video: "", audio: "" }; }
  });
  const isEnded = live_info?.live_status === "종료";
  const isOnAir = live_info?.live_status === "방송중";
  const isRehearsal = live_info?.live_status === "리허설";
  const hasBroadcastSession = isOnAir || isRehearsal;
  useEffect(() => {
    setExternalBroadcast(false);
    setBroadcastStatusChecked(false);
    setResumeLocalBroadcast(false);
    observedExternalBroadcast.current = false;
  }, [seq, hasBroadcastSession]);
  const isLocalBrowser = ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);
  const openingAt = parseLiveClosingTime(live_start);
  const closingAt = parseLiveClosingTime(live_finish);
  const outsideScheduledTime = () => !live_info?.integration_test && (openingAt === null || closingAt === null
    || Date.now() < openingAt - 5 * 60 * 1000 || Date.now() >= closingAt);
  const [now, setNow] = useState(Date.now);
  const canRestart = isEnded && (live_info?.integration_test || (openingAt !== null && closingAt !== null
    && now >= openingAt - 5 * 60 * 1000 && now < closingAt));
  const isClosed = isEnded && !canRestart;
  const [rehearsalNotice, setRehearsalNotice] = useState<"warning" | null>(null);
  const warnedRehearsal = useRef(false);
  const rehearsalRemaining = (openingAt ?? NaN) - now;
  const rehearsalAllowed = live_info?.integration_test || rehearsalRemaining > 5 * 60 * 1000;
  const rehearsalStart = live_info?.live_status === "예약" && rehearsalAllowed;
  const liveRemaining = (closingAt ?? NaN) - now;
  const deadlineReached = (isOnAir || (livestart === "start" && !isRehearsal))
    && Number.isFinite(liveRemaining) && liveRemaining <= 0;
  const showEndWarning = isOnAir && liveRemaining > 0 && liveRemaining <= 5 * 60 * 1000;
  useEffect(() => {
    const updateNow = () => setNow(Date.now());
    const timer = window.setInterval(updateNow, 1000);
    window.addEventListener('focus', updateNow);
    document.addEventListener('visibilitychange', updateNow);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', updateNow);
      document.removeEventListener('visibilitychange', updateNow);
    };
  }, []);

  useEffect(() => {
    set_Data(null);
  }, [live_info?.seq]);


  useEffect(() => {

    // Amazon IVS SDK 동적 로드

    const script = document.createElement("script");

    script.src =

      "https://web-broadcast.live-video.net/1.16.0/amazon-ivs-web-broadcast.js";

    script.async = true;

    document.body.appendChild(script);

    script.onload = async () => {

      if (!mounted.current) return;
      // SDK 로드 후 권한 확인

      setSdkReady(true);
      await checkPermissions();

    };
    script.onerror = () => {
      if (mounted.current) setConnectionError("송출 프로그램을 불러오지 못했습니다. 네트워크를 확인한 뒤 새로고침해주세요.");
    };

    return () => {

      script.onload = null;
      script.onerror = null;
      document.body.removeChild(script); // cleanup

    };

  }, []);



  const checkPermissions = async () => {

    if (!mounted.current) return;
    try {

      const cameraPermission = await navigator.permissions.query({

        name: "camera" as PermissionName,

      });

      const microphonePermission = await navigator.permissions.query({

        name: "microphone" as PermissionName,

      });



      if (

        cameraPermission.state === "granted" &&

        microphonePermission.state === "granted"

      ) {

        // 권한이 이미 허용되어 있으면 장치 목록을 초기화합니다.

        await initializeDeviceSelect();

      } else {

        // 권한이 허용되어 있지 않으면 requestPermissions 호출

        await requestPermissions();
      }

    } catch (err) {

      // Some browsers do not support camera/microphone Permissions API queries.
      await requestPermissions();
    }

  };



  const initializeDeviceSelect = async () => {

    if (!mounted.current) return;
    const devices = await navigator.mediaDevices.enumerateDevices();

    if (!mounted.current) return;
    const videoDevices = devices.filter((d) => d.kind === "videoinput");

    const audioDevices = devices.filter((d) => d.kind === "audioinput");



    setVideoDevices(videoDevices);

    setAudioDevices(audioDevices);

    setDevicesReady(true);
  };



  const requestPermissions = async () => {

    if (!mounted.current) return;
    let stream: MediaStream | undefined;
    try {

      stream = await navigator.mediaDevices.getUserMedia({video: true, audio: true});
      if (mounted.current) await initializeDeviceSelect();
    } catch (err) {

      if (!mounted.current) return;
      console.error("카메라 또는 마이크 권한이 거부되었습니다.", err);

      const message = "카메라와 마이크 권한이 필요합니다. 장치 연결 후 브라우저 설정에서 권한을 허용해 주세요.";
      setConnectionError(message);
      alert(message);
    } finally {
      stream?.getTracks().forEach(track => track.stop());
    }

  };



  const get_live_info = () => {

    axios

      .get(url.Communication_url.get_live_info, {

        params: {

          seq: seq,

        },

      })

      .then(function (response) {

        if (!mounted.current) return;
        set_Live_Info(endedBroadcast.current ? { ...response.data, live_status: "종료" } : response.data);
        setLive_start(response.data.live_start || "");

        setLive_finish(response.data.live_finish || "");

      })

      .catch(function (error) {

        // console.log("get-live-info error", error);

      });

  };



  useEffect(() => {

    seq !== "undefined" && get_live_info();



    return () => {

    };

  }, []);



  useEffect(() => {
    if (!seq || !live_info?.seq) return;
    let disposed = false;
    let pending = false;
    const refreshTitle = async () => {
      if (document.hidden || pending) return;
      pending = true;
      try {
        const { data: latest } = await axios.get(url.Communication_url.get_live_info, {
          params: { seq }, timeout: 10000,
        });
        if (disposed || Number(latest?.seq) !== Number(seq) || typeof latest?.live_title !== 'string') return;
        // Refresh metadata without restarting the camera; also honor an end confirmed by the server.
        if (latest.live_finish) setLive_finish(latest.live_finish);
        const resumed = latest.live_status === "방송중" && (parseLiveClosingTime(latest.live_finish) ?? 0) > Date.now();
        if (resumed) setAutomaticallyEnded(false);
        set_Live_Info(current => {
          if (!current || current.seq !== latest.seq) return current;
          const status = latest.live_status === "종료" || (current.live_status === "종료" && resumed)
            ? latest.live_status : current.live_status;
          const startedAt = typeof latest.start_dt === 'string' ? latest.start_dt : current.start_dt;
          return current.live_title !== latest.live_title || current.live_status !== status || current.start_dt !== startedAt
            ? { ...current, live_title: latest.live_title, live_status: status, start_dt: startedAt } : current;
        });
      } catch { /* Keep the last confirmed title while the connection recovers. */ }
      finally { pending = false; }
    };
    const timer = window.setInterval(refreshTitle, 5000);
    window.addEventListener('focus', refreshTitle);
    document.addEventListener('visibilitychange', refreshTitle);
    return () => {
      disposed = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', refreshTitle);
      document.removeEventListener('visibilitychange', refreshTitle);
    };
  }, [seq, live_info?.seq]);

  const Live_Start = () => {

    if (hasBroadcastSession) {
      observedExternalBroadcast.current = false;
      setReconnectAttempt(attempt => attempt + 1);
      return;
    }
    if (selectedVideo === "" || selectedAudio === "") {

      alert("비디오 장치와 오디오 장치를 선택해주세요");

    } else if (outsideScheduledTime()) {
      if (rehearsalStart) void live_status(true);
      else alert("라이브는 예약 시작 5분 전부터 예약 종료 전까지 시작할 수 있습니다.");
    } else {

      // if (/iPhone|iPad|iPod/i.test(userAgent)) {

      live_status();

      // } else {

      //   alert("송출 가능한 기기가 아닙니다.");

      // }

    }

  };



  const broadcastErrorMessage = (error: any) => {
    if (isLocalBrowser && error?.response?.status >= 500 && error?.config?.url?.includes("aws-ivs/live-status")) {
      return "로컬 송출 서버의 방송 상태 조회에 실패했습니다. AWS IVS 조회 권한과 채널 설정을 확인해 주세요.";
    }
    const message = error?.response?.data?.message || error?.message;
    return typeof message === "string" && message !== "Internal server error"
      ? message : "송출 서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.";
  };

  const broadcastFailed = (error: any, showAlert = !restartPreparing) => {
    if (endedBroadcast.current) return;
    statusLock.current = false;
    if (!mounted.current) return;
    localBroadcast.current = false;
    reconnecting.current = false;
    setLivestart("end");
    setStatusPending(false);
    const detail = broadcastErrorMessage(error);
    setConnectionError(detail);
    setRestartPreparing(false);
    if (showAlert) alert(detail);
    get_live_info();
  };

  const broadcastStarted = async () => {
    if (!mounted.current || endedBroadcast.current) throw new Error("방송 시작이 취소되었습니다.");
    if (!isRehearsal && closingAt !== null && Date.now() >= closingAt) {
      throw new Error("예약된 라이브 종료 시간이 지났습니다.");
    }
    if (isRehearsal && ((openingAt ?? NaN) - Date.now()) <= 5 * 60 * 1000) {
      throw new Error("예약 시작 5분 전이 되어 리허설이 종료되었습니다.");
    }
    // Reconnecting an existing broadcast must not reinitialize its start time or inventory.
    const firstLiveStart = !reconnecting.current && !isRehearsal && !localBroadcast.current;
    if (firstLiveStart) {
      await modify_live_status("시작");
      set_Live_Info(current => current ? { ...current, live_status: "방송중" } : current);
    }
    localBroadcast.current = true;
    setExternalBroadcast(false);
    observedExternalBroadcast.current = false;
    rememberStopped(false);
    setRestartPreparing(false);
    reconnecting.current = false;
    setConnectionError("");
    statusLock.current = false;
    setCameraUnavailable(false);
    if (mounted.current) {
      setStatusPending(false);
      get_live_info();
      if (firstLiveStart) setShowStartNotification(true);
    }
  };

  useEffect(() => {
    if (isClosed || !devicesReady || localBroadcast.current || externalBroadcast) return;
    setSelectedVideo(current => videoDevices.find(device => device.deviceId === (current || savedDevices.video))?.deviceId || videoDevices[0]?.deviceId || "");
    setSelectedAudio(current => audioDevices.find(device => device.deviceId === (current || savedDevices.audio))?.deviceId || audioDevices[0]?.deviceId || "");
    if (!videoDevices.length || !audioDevices.length) {
      setConnectionError("카메라와 마이크를 찾지 못했습니다. 장치를 연결한 뒤 새로고침해주세요.");
    }
  }, [isClosed, devicesReady, videoDevices, audioDevices, savedDevices, externalBroadcast]);

  useEffect(() => {
    if (!devicesReady || !selectedVideo || !selectedAudio) return;
    try {
      sessionStorage.setItem(deviceStorageKey, JSON.stringify({ video: selectedVideo, audio: selectedAudio }));
    } catch { /* Device selection still works when browser storage is unavailable. */ }
  }, [devicesReady, selectedVideo, selectedAudio, deviceStorageKey]);

  useEffect(() => {
    if (!live_finish || (!live_info?.integration_test && isOnAir && moment(live_finish).diff(moment()) <= 0) || (isRehearsal && !rehearsalAllowed) || !hasBroadcastSession || localBroadcast.current || (statusLock.current && !reconnecting.current)) return;
    let active = true;
    let timer: number | undefined;
    const deadline = Date.now() + 30000;
    statusLock.current = true;
    reconnecting.current = true;
    endedBroadcast.current = false;
    setStatusPending(true);
    setResumeLocalBroadcast(false);
    setConnectionError("");
    let releasedPreviousStart = false;
    let wasOwnStart = false;
    const reconnect = async () => {
      try {
        if (!releasedPreviousStart) {
          const key = `fanbird.broadcast.start.${seq}`;
          let token: string | null = null;
          try { token = sessionStorage.getItem(key); } catch { /* Storage may be unavailable. */ }
          if (token) {
            wasOwnStart = true;
            await api.post(url.Communication_url.release_broadcast_start,
              { live_seq: Number(seq), broadcast_token: token }, { timeout: 5000 });
            if (!active) return;
            try { if (sessionStorage.getItem(key) === token) sessionStorage.removeItem(key); }
            catch { /* The server already released this reservation. */ }
          }
          releasedPreviousStart = true;
        }
        const { data } = await api.get(url.Communication_url.live_status, { timeout: 5000 });
        if (!active) return;
        setBroadcastStatusChecked(true);
        if (data.isLive) {
          if (!wasOwnStart || Date.now() >= deadline) {
            observedExternalBroadcast.current = true;
            setExternalBroadcast(true);
            setConnectionError("");
            setStatusPending(false);
            statusLock.current = false;
            reconnecting.current = false;
            timer = window.setTimeout(() => void reconnect(), 5000);
            return;
          }
          // The previous page's connection may still be closing. Never terminate another sender.
          timer = window.setTimeout(() => void reconnect(), 2000);
          return;
        }
        if (observedExternalBroadcast.current) {
          setExternalBroadcast(false);
          setStatusPending(false);
          statusLock.current = false;
          reconnecting.current = false;
          setConnectionError("다른 기기의 송출이 끊겼습니다. PC에서 이어 송출하려면 ‘송출 재연결’을 눌러주세요.");
          return;
        }
        setStatusPending(false);
        statusLock.current = false;
        reconnecting.current = false;
        setResumeLocalBroadcast(true);
      } catch (error: any) {
        if (!active) return;
        statusLock.current = false;
        reconnecting.current = false;
        setStatusPending(false);
        setConnectionError(broadcastErrorMessage(error));
      }
    };
    void reconnect();
    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [seq, hasBroadcastSession, isOnAir, live_finish, isRehearsal, rehearsalAllowed, reconnectAttempt]);

  useEffect(() => {
    if (!resumeLocalBroadcast || !sdkReady || !selectedVideo || !selectedAudio || localBroadcast.current || observedExternalBroadcast.current || endedBroadcast.current) return;
    statusLock.current = true;
    reconnecting.current = true;
    setStatusPending(true);
    setResumeLocalBroadcast(false);
    setLivestart("start");
  }, [resumeLocalBroadcast, sdkReady, selectedVideo, selectedAudio]);

  useEffect(() => {
    if ((!isEnded && !deadlineReached) || endedBroadcast.current) return;
    endedBroadcast.current = true;
    // Stop this browser's sender immediately. The server ends the live even if this tab is closed.
    stoppingBroadcast.current = broadcastRef.current?.stop() ?? Promise.resolve();
    void stoppingBroadcast.current.catch(() => {
      if (mounted.current) setConnectionError("송출 연결을 정리하고 있습니다. 서버에서 종료 상태를 확인합니다.");
    });
    localBroadcast.current = false;
    reconnecting.current = false;
    statusLock.current = false;
    setStatusPending(false);
    setLivestart("end");
    setShowStartNotification(false);
    set_Live_Time("00:00:00");
    set_Viewer_Count(0);
    setConnectionError("");
    if (deadlineReached) {
      setAutomaticallyEnded(true);
      set_Live_Info(current => current ? { ...current, live_status: "종료" } : current);
    }
  }, [isEnded, deadlineReached]);

  const live_status = async (rehearsal = false) => {
    if (statusLock.current) return;
    if (!rehearsal && outsideScheduledTime()) {
      setConnectionError("라이브는 예약 시작 5분 전부터 예약 종료 전까지 시작할 수 있습니다.");
      return;
    }
    if (rehearsal && ((openingAt ?? NaN) - Date.now()) <= 5 * 60 * 1000) {
      setConnectionError("리허설은 예약 시작 5분 전까지만 가능합니다.");
      return;
    }
    const restarting = canRestart || previouslyStopped.current;
    statusLock.current = true;
    setStatusPending(true);
    setRestartPreparing(restarting);
    setConnectionError("");
    endedBroadcast.current = false;
    setAutomaticallyEnded(false);
    const deadline = Date.now() + 65000;
    const prepare = async () => {
      try {
        await stoppingBroadcast.current;
        if (!mounted.current) return;
        if (!rehearsal && outsideScheduledTime()) throw new Error("예약된 라이브 종료 시간이 지났습니다.");
        if (rehearsal && ((openingAt ?? NaN) - Date.now()) <= 5 * 60 * 1000) {
          throw new Error("리허설은 예약 시작 5분 전까지만 가능합니다.");
        }
        const { data } = await api.get(url.Communication_url.live_status, { timeout: 5000 });
        if (!mounted.current) return;
        if (data.isLive) {
          if (!restarting) throw new Error("이미 송출 중인 방송이 있습니다. 현재 송출 상태를 확인해주세요.");
          if (Date.now() >= deadline) throw new Error("기존 송출 종료를 확인하지 못했습니다. 다른 탭이나 기기의 송출 상태를 확인한 뒤 다시 시도해주세요.");
          restartTimer.current = setTimeout(() => void prepare(), 2000);
          return;
        }
        // Recheck the scheduled window after the server response as well.
        if (!rehearsal && outsideScheduledTime()) throw new Error("예약된 라이브 종료 시간이 지났습니다.");
        if (rehearsal) {
          if (((openingAt ?? NaN) - Date.now()) <= 5 * 60 * 1000) throw new Error("리허설은 예약 시작 5분 전까지만 가능합니다.");
          await modify_live_status("리허설");
          if (!mounted.current) return;
          set_Live_Info(current => current ? { ...current, live_status: "리허설" } : current);
        }
        setLivestart("start");
      } catch (error) {
        broadcastFailed(error, !restarting);
      }
    };
    await prepare();
  };


  const modify_live_status = async (item: string) => {

    await api.post(url.Communication_url.motify_live_status, {

      seq: seq,

      status: item,

    });

  };



  const Live_End = async () => {
    if (statusLock.current || externalBroadcast || observedExternalBroadcast.current || (hasBroadcastSession && !localBroadcast.current && !broadcastStatusChecked)) return;
    statusLock.current = true;
    setStatusPending(true);
    try {
      stoppingBroadcast.current = broadcastRef.current?.stop() ?? Promise.resolve();
      await stoppingBroadcast.current;
      if (isRehearsal) {
        await modify_live_status("예약");
      } else {
        await api.post(url.Communication_url.force_quit, { live_seq: Number(seq) });
      }
      rememberStopped(true);
      localBroadcast.current = false;
      reconnecting.current = false;
      setConnectionError("");
      setLivestart("end");
      set_Live_Info((current) => current ? { ...current, live_status: isRehearsal ? "예약" : "종료" } : current);
      set_Live_Time("00:00:00");
      set_Viewer_Count(0);
    } catch (error) {
      console.error("방송 종료 실패:", error);
      alert("방송 종료를 완료하지 못했습니다. 다시 시도해주세요.");
    } finally {
      statusLock.current = false;
      if (mounted.current) setStatusPending(false);
    }
  };


  useEffect(() => {
    if (!isRehearsal) {
      warnedRehearsal.current = false;
      setRehearsalNotice(current => current === "warning" ? null : current);
      return;
    }
    let active = true;
    let ending = false;
    const tick = async () => {
      const remaining = ((openingAt ?? NaN) - Date.now());
      if (!active || ending || !Number.isFinite(remaining)) return;
      if (remaining <= 5 * 60 * 1000) {
        ending = true;
        try {
          await broadcastRef.current?.stop();
          if (!active) return;
          // Only revert this rehearsal; a separate sender may already have started the live.
          const { data: current } = await api.get(url.Communication_url.get_live_info, { params: { seq } });
          if (current.live_status === "리허설") await modify_live_status("예약");
          if (!active) return;
          localBroadcast.current = false;
          reconnecting.current = false;
          statusLock.current = false;
          setStatusPending(false);
          setLivestart("end");
          set_Live_Info(current => current ? { ...current, live_status: "예약" } : current);
          set_Live_Time("00:00:00");
          set_Viewer_Count(0);
          Navigate("/admin/livelist", { replace: true, state: { rehearsalEnded: true } });
        } catch {
          if (active) setConnectionError("리허설 종료 상태를 확인하고 있습니다. 잠시 후 자동으로 다시 확인합니다.");
          ending = false;
        }
      } else if (remaining <= 6 * 60 * 1000 && !warnedRehearsal.current) {
        warnedRehearsal.current = true;
        setRehearsalNotice("warning");
      }
    };
    void tick();
    const timer = window.setInterval(() => void tick(), 1000);
    return () => { active = false; window.clearInterval(timer); };
  }, [isRehearsal, openingAt, seq, Navigate]);

  const { notices: purchaseNotices, showPurchaseNotice } = usePurchaseNotices();
  const changePriceVisibility = async () => {
    if (!data) return;
    const productSeq = data.seq;
    const mode = data.exposure_price_mode === undefined || data.exposure_price_mode === 'visible' ? 'seller' : 'visible';
    const response = await api.patch(url.Communication_url.product_update, {
      live_seq: Number(seq), product_list: [{ seq: productSeq, exposure_price_mode: mode }],
    }, { headers: { 'Content-Type': 'application/json' } });
    if (response.data?.total !== 1 || response.data?.success !== 1 || response.data?.fail !== 0) throw new Error('Price disclosure failed');
    set_Data(current => current?.seq === productSeq ? { ...current, exposure_price_mode: mode } : current);
  };


  // 소켓

  const [socket, setSocket] = useState<Socket | null>(null);



  useEffect(() => {

    if (seq === "undefined") {

      alert("방송정보가 없습니다.");

      Navigate("/", { replace: true });

    }

    if (live_info) {

      let active = true;
      let productRequest = 0;
      const restoreProduct = async () => {
        const request = ++productRequest;
        try {
          const response = await axios.get(url.Communication_url.is_visable_product, {
            params: { live_seq: seq },
          });
          if (active && request === productRequest) {
            set_Data(hasProductExposure(response.data) ? response.data : null);
          }
        } catch { /* Keep the current product until the next successful connection. */ }
      };
      // The sender uses its camera preview, so exposure changes apply immediately.
      const updateProduct = (item: props_data_type | null) => {
        productRequest += 1;
        setProductInfoSyncVersion(version => version + 1);
        set_Data(hasProductExposure(item) ? item : null);
      };
      if (seq !== 'undefined') void restoreProduct();


      // 소켓 연결을 초기화합니다.

      const newSocket = io(SOCKET_SERVER_URL, {

        path: "/socket.io", // nginx에서 location /live/로 프록시 중이므로 필요

        transports: ["websocket"], // polling을 비활성화하고 WebSocket만 사용

      });

      setSocket(newSocket);



      newSocket.on("connect", () => {

        newSocket.emit("join-channel", { channelId: live_info?.channel_name });
        setProductInfoSyncVersion(version => version + 1);

        void restoreProduct();
      });

      newSocket.on("Live Q&A Updated", (update: { liveSeq: number }) => qaUpdated(update.liveSeq));
      newSocket.on("Seller Notice Updated", (update: { liveSeq: number }) => sellerNoticeUpdated(update.liveSeq));
      newSocket.on("Live Notice", (notices: { content: string }[]) => {
        if (Array.isArray(notices)) setLiveNotice(typeof notices[0]?.content === 'string' ? notices[0].content : '');
      });
      newSocket.on("Product List Changed", (update: { liveSeq: number }) => {
        if (Number(update?.liveSeq) !== Number(seq)) return;
        setProductInfoSyncVersion(version => version + 1);
      });

      newSocket.on("Inventory Changed", (inventory: { productSeq: number; currentCnt: number }) => {
        if (!Number.isSafeInteger(inventory?.productSeq) || !Number.isFinite(inventory.currentCnt)) return;
        setStockCounts(counts => ({ ...counts, [inventory.productSeq]: inventory.currentCnt }));
      });



      newSocket.on("Viewer Count", (data: string) => {

        // console.log("Viewer Count : ", data);

        set_Viewer_Count(Number(data));

      });

      newSocket.on("Stock", updateProduct);
      newSocket.on("Stock Over", updateProduct);
      // 컴포넌트가 언마운트될 때 소켓 연결을 정리합니다.

      return () => {

        active = false;
        newSocket.disconnect();

      };

    }

  }, [live_info?.channel_name, seq]);



  return (

    <>
      <LiveDetail adminLevel={adminLevel} adminPermissions={adminPermissions} broadcast={{
        status: live_info?.live_status ?? null,
        socket,
        refreshVersion: productInfoSyncVersion,
        captureReady: livestart === "start" && !statusPending && localBroadcast.current,
        renderPreview: (chatTarget, sellerNotice, totalSales) => <>
        <Streaming_Box role="region" aria-label="라이브 영상">

          <VideoFrame>
          <CameraLayer hidden={livestart !== "start" && !hasBroadcastSession && !reviewHost}>
          <AdminLive
            ref={broadcastRef}
            hostStatusTarget={hostStatusTarget}
            productCameraTarget={productCameraTarget}
            cameraEnabled={cameraEnabled}
            microphoneEnabled={microphoneEnabled}
            onCameraDisconnected={() => {
              toggleDevice("cameraEnabled", false);
              setCameraUnavailable(true);
              setConnectionError("카메라 연결이 끊겨 화면을 가렸습니다. 카메라를 연결한 뒤 송출을 다시 시작해주세요.");
            }}
            livestart={livestart}

            onStarted={broadcastStarted}
            onError={broadcastFailed}
            selectedVideo_props={selectedVideo}

            selectedAudio_props={selectedAudio}

            live_info={live_info}

          />

          {externalBroadcast && <ExternalBroadcastBox role="status" aria-label="다른 기기 송출 상태">
            <strong>앱 또는 다른 기기에서 송출 중</strong>
            <p>카메라·마이크는 송출 중인 기기에서 조작해주세요.</p>
            <p>영상은 라이브 상세보기에서 확인할 수 있습니다.</p>
          </ExternalBroadcastBox>}
          </CameraLayer>
          {livestart !== "start" && !hasBroadcastSession && !reviewHost && <IdlePreview>
            <LivePreviewState status={isEnded ? "종료" : "예약"} onBrowse={() => Navigate("/admin/livelist")} />
          </IdlePreview>}


          <VideoAlerts aria-label="라이브 영상 알림" hidden={(!hasBroadcastSession && livestart !== "start" && !reviewHost) || (!liveNotice.trim() && !purchaseNotices.length && (Boolean(chatTarget) || !sellerNotice.trim()))}>

          {liveNotice.trim() && <LiveNoticeBox role="note" aria-label="라이브 공지"><ExpandableNotice content={liveNotice} html previewLength={15} consumeOutsideClick deferResize /></LiveNoticeBox>}
          <PurchaseNoticeAnchor>
            {purchaseNotices.length > 0 && <PurchaseNotice role="log" aria-label="구매 완료 알림" aria-live="polite" aria-relevant="additions">
              {purchaseNotices.map(notice => <div key={notice.id}>{notice.content}</div>)}
            </PurchaseNotice>}
          </PurchaseNoticeAnchor>
          </VideoAlerts>
          {!externalBroadcast && <HostGuidance className="web-broadcast-host-guidance" ref={setHostStatusTarget} />}

          <Bottom_Box>
                {(hasBroadcastSession || livestart === "start" || reviewHost) && data && hasProductExposure(data) && (
                  <BroadcastProductCard product={data} liveSeq={Number(seq)} rehearsal={isRehearsal}
                    onChangePriceVisibility={adminLevel === 'master' || adminPermissions.includes('product_manage') ? changePriceVisibility : undefined}
                    imageUrl={productImages[0] || mediaUrl(data.thumbnail_img)}
                    count={stockCounts[data.seq] ?? data.current_cnt} />
                )}
          </Bottom_Box>
          <ProductCameraLayer ref={setProductCameraTarget} />
          </VideoFrame>
          <Status_Box aria-label="라이브 진행 현황">
            <RowView2>

              <LiveStatusBadge status={hasBroadcastSession || isEnded ? live_info?.live_status : livestart === "start" ? "연결 중" : "준비"} />
              <Time_Box>

                <Shadow_Icon

                  src={require("../../../Image/ic_time_white.png")}

                />

                &nbsp;{live_time}

              </Time_Box>

              <Viewer_Count_Box>

                <Shadow_Icon

                  src={require("../../../Image/ic_viewer_white.png")}

                />

                &nbsp;{viewer_count}명
              </Viewer_Count_Box>

            </RowView2>


          </Status_Box>
          {totalSales !== undefined && <LiveSalesTotal total={totalSales} />}
          {!isClosed && !externalBroadcast && <BroadcastControls aria-label="카메라와 마이크 조작">
            <DeviceToggle type="button" aria-pressed={cameraEnabled}
              disabled={statusPending || cameraUnavailable} onClick={() => toggleDevice("cameraEnabled")}>
              {cameraEnabled ? "카메라 ON" : "카메라 OFF"}
            </DeviceToggle>
            <DeviceToggle type="button" aria-pressed={microphoneEnabled}
              disabled={statusPending} onClick={() => toggleDevice("microphoneEnabled")}>
              {microphoneEnabled ? "마이크 ON" : "마이크 OFF"}
            </DeviceToggle>

          </BroadcastControls>}
          {hasBroadcastSession && livestart === "end" && (
            <Start_Btn as="button" type="button" aria-busy={statusPending}
              disabled={statusPending || externalBroadcast || !broadcastStatusChecked} $state="start"
              $select_cam={selectedVideo} $select_mic={selectedAudio}
              onClick={() => void Live_End()}>
              {isRehearsal ? "리허설 종료" : "라이브 종료"}
            </Start_Btn>
          )}
          {!externalBroadcast && (!hasBroadcastSession || livestart !== "end" || connectionError || (statusPending && reconnecting.current)) && <Start_Btn
              as="button"
              type="button"
              aria-busy={statusPending}
              disabled={statusPending || (!isClosed && livestart === "end" && (!sdkReady || selectedAudio === "" || selectedVideo === "" || (!hasBroadcastSession && outsideScheduledTime() && !rehearsalStart) || (isRehearsal && !rehearsalAllowed)))}
              $state={livestart}

              $select_cam={selectedVideo}

              $select_mic={selectedAudio}

              onClick={() => {
                if (isClosed) {
                  Navigate("/admin/livelist/make");
                  return;
                }
                livestart === "end" ? Live_Start() : Live_End();
              }}
            >
              {statusPending ? (restartPreparing ? "재시작 준비 중" : reconnecting.current ? "재연결 중" : "처리 중") : isClosed ? "새 라이브 만들기" : livestart === "end" ? (hasBroadcastSession ? "송출 재연결" : canRestart ? "다시 방송하기" : rehearsalStart ? "리허설 시작" : "라이브 시작") : isRehearsal ? "리허설 종료" : "라이브 종료"}
            </Start_Btn>}



          {(!isEnded && !isOnAir) && (
            <ConnectionNotice role="note">
              {isRehearsal ? "리허설은 예약 시작 6분 전에 경고하고, 5분 전에 자동 종료 후 목록으로 돌아갑니다." : rehearsalAllowed ? "예약 시작 5분 전까지 리허설로 영상·채팅을 테스트할 수 있습니다." : "라이브는 예약 시작 5분 전부터 예약 종료 전까지 시작할 수 있습니다."}
              {" "}예약 시간은 변경되지 않습니다.
              {!isRehearsal && !rehearsalStart && <RehearsalButton type="button"
                disabled={statusPending || !sdkReady || !selectedVideo || !selectedAudio || !rehearsalAllowed}
                onClick={() => void live_status(true)}>리허설 시작</RehearsalButton>}
            </ConnectionNotice>
          )}
          {(showEndWarning || automaticallyEnded) && (
            <ConnectionNotice role="alert" aria-atomic="true">
              {automaticallyEnded
                ? "예약된 종료 시간이 되어 라이브가 자동 종료되었습니다."
                : `라이브 종료까지 5분 이내로 남았습니다. ${moment(live_finish).format("HH:mm")}에 자동 종료됩니다. 방송을 마무리해주세요.`}
            </ConnectionNotice>
          )}
          {(connectionError || (statusPending && (restartPreparing || reconnecting.current))) && (
            <ConnectionNotice role={connectionError ? "alert" : "status"}>
              {connectionError || (restartPreparing ? "기존 송출 종료를 확인하고 있습니다. 준비가 완료되면 자동으로 시작합니다." : "방송에 다시 연결하고 있습니다…")}
            </ConnectionNotice>
          )}
          {livestart === "end" && !isClosed && !externalBroadcast && (
            <Device_Select_Box>

              <div>

                <Icon src={icon_question_circle_gray} />

                촬영 장치 선택

              </div>

              <select

                id="video-devices"

                aria-label="촬영 장치 선택"
                value={selectedVideo}

                onChange={(e) => setSelectedVideo(e.target.value)} // 상태 업데이트

                disabled={statusPending || videoDevices.length === 0}
              >

                <option value="" disabled>

                  카메라 선택

                </option>

                {videoDevices.map((device) => (

                  <option key={device.deviceId} value={device.deviceId}>

                    {device.label || `Camera ${device.deviceId}`}

                  </option>

                ))}

              </select>

              <div>
                <Icon src={icon_question_circle_gray} />

                녹음 장치 선택

              </div>

              <select

                id="audio-devices"
                aria-label="녹음 장치 선택"
                value={selectedAudio}

                onChange={(e) => setSelectedAudio(e.target.value)} // 상태 업데이트

                disabled={statusPending || audioDevices.length === 0}
              >

                <option value="" disabled>

                  마이크 선택

                </option>

                {audioDevices.map((device) => (

                  <option key={device.deviceId} value={device.deviceId}>

                    {device.label || `Microphone ${device.deviceId}`}

                  </option>

                ))}

              </select>

            </Device_Select_Box>

          )}



        </Streaming_Box>

          {chatTarget && createPortal(<StyleSheetManager target={document.head}><LiveChatContent liveInfo={live_info} liveSeq={Number(seq)} onPurchaseNotification={showPurchaseNotice} moderationFilters showNicknameSeparator={false} /></StyleSheetManager>, chatTarget)}
        </>,
      }} />
      {showStartNotification && livestart === "start" && !isRehearsal && !isEnded && (
        <StartNotificationSheet liveSeq={Number(seq)} onDismiss={dismissStartNotification} onSent={startNotificationSent} />
      )}
      {notificationMessage && <NotificationFeedback role="status">{notificationMessage}</NotificationFeedback>}
      {rehearsalNotice && <RehearsalOverlay>
        <RehearsalDialog role="alertdialog" aria-modal="true" aria-labelledby="rehearsal-title" aria-describedby="rehearsal-description">
          <h2 id="rehearsal-title">리허설 종료 예정</h2>
          <p id="rehearsal-description">예약 시작 5분 전이 되면 리허설을 자동 종료하고 목록으로 돌아갑니다. 목록에서 라이브를 시작해주세요.</p>
          <button type="button" autoFocus onClick={() => setRehearsalNotice(null)}>확인</button>
        </RehearsalDialog>
      </RehearsalOverlay>}
    </>
  );

};



export default Live_Manage;



const Streaming_Box = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding-bottom: var(--space-2);
  color: var(--color-text-primary);
`;
const VideoFrame = styled.div.attrs<{ 'data-live-media-display'?: boolean }>({ 'data-live-media-display': true })`
  width: 100%;
  min-width: 0;
  aspect-ratio: 9 / 16;
  container-type: inline-size;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--color-bg-sidebar);
  color: var(--color-text-on-brand);
  border-radius: var(--radius-md);
  canvas { object-fit: cover; }
`;
const LiveNoticeBox = styled.div`
  position: relative; z-index: 1; flex-shrink: 0; min-width: 0;
  margin: 0; padding: var(--space-3);
  border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
  background: var(--color-bg-surface); color: var(--color-text-primary);
  font-size: var(--text-caption); line-height: var(--leading-caption);
`;
const IdlePreview = styled.div`
  position: absolute; inset: 0; display: grid;
  > * { height: 100%; min-height: 0; }
`;
const CameraLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;

`;
const ProductCameraLayer = styled.div`
  position: absolute; inset: 0; z-index: 100; pointer-events: none;
  .product-camera-prompt {
    top: var(--space-3); bottom: auto;
    max-height: calc(100% - 24px); overflow-y: auto; box-sizing: border-box;
    flex-wrap: wrap; gap: var(--space-2);
  }
`;
const ExternalBroadcastBox = styled.div`
  position: absolute; inset: 0; display: flex; flex-direction: column;
  justify-content: center; align-items: center; padding: var(--space-4); gap: var(--space-3);
  box-sizing: border-box; text-align: center; background: var(--color-bg-sidebar);
  color: var(--color-text-on-brand); font-size: var(--text-body); line-height: 1.5;
  strong { font-size: var(--text-h3); }
  p { margin: 0; }
`;
const Start_Btn = styled.button<Live_Start_Props>`
  min-height: var(--control-md);
  margin-top: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  border-color: ${props => props.$state === "end" ? "var(--color-border-default)" : "#85818d"};
  background: ${props => props.$state === "end" ? "var(--gradient-brand)" : "#211e29"};
  color: ${props => props.$state === "end" ? "var(--color-text-on-brand)" : "#f0f0f2"};
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  &:disabled { background: var(--color-bg-muted); border-color: var(--color-border-strong); color: var(--color-text-disabled); cursor: not-allowed; }
`;
const Status_Box = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  padding: var(--space-3) 0;
  > div { flex-wrap: nowrap; gap: var(--space-2); }
`;
const Time_Box = styled.div`
  display: flex;
  align-items: center;
  color: var(--color-text-on-brand);
  font-size: var(--text-body);
`;
const Viewer_Count_Box = styled(Time_Box)``;
const Shadow_Icon = styled(Icon)``;
const Device_Select_Box = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3);
  background: var(--color-bg-subtle);
  border-radius: var(--radius-md);
  color: var(--color-text-primary);
  font-size: var(--text-body);
  div { display: flex; align-items: center; gap: var(--space-2); }
  select {
    box-sizing: border-box;
    min-height: var(--control-md);
    width: 100%;
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    padding: 0 var(--space-3);
    color: var(--color-text-primary);
    background: var(--color-bg-surface);
    font: inherit;
  }
`;
const ConnectionNotice = styled.div`
  padding: var(--space-3);
  margin-top: var(--space-3);
  border-radius: var(--radius-md);
  background: var(--color-bg-muted);
  color: var(--color-text-secondary);
  font-size: var(--text-body);
  line-height: 1.5;
`;

const VideoAlerts = styled.div`
  position: relative;
  z-index: 60;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 16px 0;
  min-width: 0;
  &[hidden] { display: none; }
`;
const PurchaseNoticeAnchor = styled.div`
  min-width: 0;
  pointer-events: none;
  &:empty { display: none; }
  > [role="log"] {
    position: static;
    max-width: 100%;
    font-size: 14px;
    line-height: 1.4;
    gap: 4px;
    text-align: right;
    > div { padding: 0; }
  }
`;
const HostGuidance = styled.div`
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px;
  pointer-events: none;
  > [role="status"] {
    position: static;
    transform: none;
    width: 100%;
  }

`;

const Bottom_Box = styled.div`
  position: relative;
  z-index: 1;
  margin-top: auto;
  padding: var(--space-3);
  min-width: 0;
  > div { margin-top: 0; }
`;

const RehearsalButton = styled.button`
  display: block;
  min-height: var(--control-md);
  margin-top: var(--space-2);
  padding: 0 var(--space-3);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: var(--color-bg-surface);
  color: var(--color-text-primary);
  font: inherit;
  cursor: pointer;
  &:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: not-allowed; }
`;
const BroadcastControls = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
  padding: var(--space-3) 0;
`;
const DeviceToggle = styled.button`
  min-height: var(--control-md);
  padding: 0 var(--space-3);
  border: 1px solid var(--color-border-default);
  border-radius: var(--radius-md);
  background: #211e29;
  border-color: #85818d;
  color: #f0f0f2;
  font: inherit;
  font-size: var(--text-caption);
  cursor: pointer;
  &[aria-pressed="false"] { background: #9f1239; border-color: #fda4af; color: #fff; }
  &:disabled { background: var(--color-bg-muted); color: var(--color-text-disabled); cursor: not-allowed; }
`;

const RehearsalOverlay = styled.div`
  position: fixed; inset: 0; z-index: 10000; padding: 24px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(0, 0, 0, .6);
`;
const RehearsalDialog = styled.div`
  width: 100%; max-width: 420px; padding: 28px; border-radius: 20px;
  background: var(--user-surface); color: var(--user-text);
  h2 { margin: 0 0 16px; font-size: 22px; }
  p { margin: 0 0 24px; font-size: 16px; line-height: 1.6; color: var(--user-text-muted); }
  button { width: 100%; min-height: 48px; border: 0; border-radius: 10px;
    background: #6035db; color: #fff; font: inherit; font-weight: 700; cursor: pointer; }
  button:focus-visible { outline: 3px solid var(--user-accent); outline-offset: 3px; }
`;

const NotificationFeedback = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: calc(24px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: calc(100vw - 48px);
  box-sizing: border-box;
  padding: 12px 16px;
  border-radius: 12px;
  background: var(--admin-theme-surface, #211e29);
  color: var(--admin-theme-text, #fff);
  font-size: 14px;
  line-height: 1.5;
`;
